'use strict';

var React = require('react');

var SvgHeartMajor = function SvgHeartMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 1a5 5 0 0 0-5 5v.448c0 5.335 2.955 9.647 8.598 12.457a.902.902 0 0 0 .804 0c5.644-2.81 8.598-7.122 8.598-12.457v-.448a5 5 0 0 0-9-3 4.992 4.992 0 0 0-4-2z"
  }));
};

exports.SvgHeartMajor = SvgHeartMajor;
